import { GlobalApiResponse } from "app/core/models/apiResponse.interface";

export class ActionGetFeedback {
  static readonly type = "[FEEDBACK] GET FEEDBACKS";
  constructor(public payload: GlobalApiResponse) {}
}
